export const Exposure = (value: number) => (srcData: any) => {
  const exposure = value; // value is already normalized between -1 and 1
  const data = srcData.data;
  const len = data.length;

  for (let i = 0; i < len; i += 4) {
    // Apply exposure adjustment (multiplicative brightness)
    const factor = Math.pow(2, exposure);

    data[i] = Math.min(255, Math.max(0, data[i] * factor)); // Red
    data[i + 1] = Math.min(255, Math.max(0, data[i + 1] * factor)); // Green
    data[i + 2] = Math.min(255, Math.max(0, data[i + 2] * factor)); // Blue
    // Alpha channel remains unchanged
  }
};
